import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../config/api";
import { BackEndRoutes } from "../../../config/back-end-routes";
import DefaultGrid from "../../../Components/Default/DefaultGrid";
import { FrontEndRoutes } from "../../../config/front-end-routes";
import { toast } from "react-toastify";
import AddTableModal from "./PageAddTabela";
import {useFilters} from "../../../Components/Filters/UseFilter";

const PagePriceTables: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [priceTables, setPriceTables] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const { filters, filteredItems, handleFilterChange, setItems } = useFilters([]);

    const columns = [
        { key: "id_tabela", label: "Código", filterType: "text" as const, disable: true },
        { key: "descricao", label: "Descrição", filterType: "text" as const },
        {
            key: "status",
            label: "Status",
            filterType: "select",
            options: [
                { value: "1", description: "Ativo" },
                { value: "0", description: "Inativo" },
            ],
            render: (item: any) => (
                <select
                    className="form-select"
                    value={item.status}
                    onChange={(e) => {
                        const newStatus = parseInt(e.target.value, 10);

                        api.put(
                            BackEndRoutes.routes.TABELA_PRECOS.FIND.replace(":id", item.id_tabela),
                            {
                                descricao: item.descricao,
                                status: newStatus,
                            }
                        )
                            .then(() => {
                                setPriceTables((prev: any) =>
                                    prev.map((i: any) =>
                                        i.id_tabela === item.id_tabela
                                            ? { ...i, status: newStatus }
                                            : i
                                    )
                                );
                                toast.success("Status atualizado com sucesso!");
                            })
                            .catch((error) => {
                                console.error("Erro ao atualizar status:", error);
                                toast.error("Erro ao atualizar status.");
                            });
                    }}
                >
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                </select>
            ),
        }
    ];

    const handleAddTableSuccess = () => {
        toast.info("Atualize a lista para ver a nova tabela.");
        handlePriceTables();
    };


    const handleEditTables = (item: any) => {
        if (item?.id_tabela) {
            navigate(FrontEndRoutes.TABELA.EDIT.replace(":id", item.id_tabela));
        }
    };

    const handleDelete = () => {
        if (!selectedItem) return;
        setLoading(true);
        api
            .delete(BackEndRoutes.routes.TABELA_PRECOS.FIND.replace(":id", selectedItem.id_tabela!))
            .then(() => {
                toast.success("Item da tabela de preços excluído com sucesso!");
                navigate(FrontEndRoutes.TABELA.PRECO);
                handlePriceTables(); // Atualiza a lista
            })
            .catch((error) => {
                toast.error("Erro ao excluir item da tabela de preços");
                console.error("Erro ao excluir item da tabela de preços:", error);
            })
            .finally(() => {
                setLoading(false);
                setSelectedItem(null); // Limpa o item selecionado
            });
    };

    const handlePriceTables = async () => {
        setLoading(true);
        try {
            const response = await api.get(BackEndRoutes.routes.TABELA_PRECOS.LIST);
            if (response.data) {
                setPriceTables(response.data);
            }
        } catch (error) {
            console.error("Erro ao buscar tabelas de preços:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handlePriceTables();
    }, []);

    return (
        <div className="d-flex flex-column container-fluid">
            <DefaultGrid
                title="Tabelas de Preço"
                onAdd={() => setShowAddModal(true)}
                columns={columns}
                filters={filters}
                handleFilterChange={handleFilterChange}
                items={priceTables}
                itemsPerPage={10}
                loading={loading}
                onReload={handlePriceTables}
                onEdit={handleEditTables}
                onDelete={(item: any) => {
                    setSelectedItem(item);
                    setShowDeleteModal(true);
                }}
            />
            {showAddModal && (
                <AddTableModal
                    onClose={() => setShowAddModal(false)}
                    onSuccess={handleAddTableSuccess}
                />
            )}
            {showDeleteModal && (
                <div className="modal" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmar Exclusão</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowDeleteModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Tem certeza que deseja excluir o item{" "}
                                    <strong>{selectedItem?.descricao}</strong> desta tabela de preços?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowDeleteModal(false)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        setShowDeleteModal(false);
                                        handleDelete(); // Chama a função de exclusão
                                    }}
                                >
                                    Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PagePriceTables;